import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';

import { DominiosResolver } from 'src/app/shared/resolvers/dominios.resolver';
import { CalculoValorHonradoRecuperarComponent } from './calculo-valor-honrado-recuperar/calculo-valor-honrado-recuperar.component';
import { RecuperacaoCreditoLoteEnvioComponent } from '../protocolo/recuperacao-credito-lote-envio.component';
import { RecuperacaoCreditoPesquisaComponent } from './recuperacao-credito-pesquisa.component';
import { RecuperacaoCreditoLotePesquisaComponent } from '../protocolo/recuperacao-credito-lote-pesquisa.component';
import { RecuperacaoCreditoDetalheComponent } from './recuperacao-credito-detalhe.component';
import { RecuperacaoCreditoCadastroComponent } from '../protocolo/recuperacao-credito-cadastro.component';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { RecuperacoesInconsistentesComponent } from './recuperacoes-inconsistentes.component';

const routes: Routes = [
  {
    path: 'recuperacoes-credito',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver
    },
    
    children: [
      {
        path: 'pesquisa',
        component: RecuperacaoCreditoPesquisaComponent,
      },
      {
        path: 'cadastro',
        component: RecuperacaoCreditoCadastroComponent,
      },
      {
        path: 'calculo-valor-honrado-recuperar',
        component: CalculoValorHonradoRecuperarComponent,
      },
      {
        path: 'lote',
        component: RecuperacaoCreditoLotePesquisaComponent,
      },
      {
        path: 'lote/envio',
        component: RecuperacaoCreditoLoteEnvioComponent,
      },
      {
        path: 'recuperacoes-inconsistentes',
        component: RecuperacoesInconsistentesComponent,
      },
      {
        path: ':id',
        component: RecuperacaoCreditoDetalheComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RecuperacaoCreditoRoutingModule { }
